import * as actions from './actions'
import {fromJS} from 'immutable';

const initState = fromJS({
    'modal': {
        'toogle': 'off',
        'route': ''
    },
    'menu':{
        'toogle': false
    },
})

function reducer(state, action)
{
    if(!state){
        state = initState;
    }

    switch (action.type) {
        // ========= READ ===========
        case actions.MODAL_ON:
            return state
                .setIn(['modal', 'route'], action.payload)
                .setIn(['modal', 'data'], action.data);
        case actions.MODAL_OFF:
            return state.setIn(['modal', 'route'], '');
        case actions.MENU_TOOGLE:
            return state.setIn(['menu', 'toogle'], action.toogle);
        default:
            return state;
      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/System/reducer.js